import { Component, EventEmitter, Output } from '@angular/core';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';
import { BaseService } from 'src/app/services/base.service';
import { UPLOAD_QRIS } from 'src/app/constants/endpoint.const';

@Component({
  standalone: false,
  selector: 'app-upload-qris',
  templateUrl: './upload-qris.component.html',
  styleUrl: './upload-qris.component.scss'
})
export class UploadQrisComponent {
  fileList: NzUploadFile[] = [];
  qrisName: string = '';

  @Output() afterUpload = new EventEmitter<void>();

  constructor(
    private baseService: BaseService,
    private message: NzMessageService) {}

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
      if (!isJpgOrPng) {
        this.message.create('error', 'You can only upload JPG/PNG file!');
        observer.complete();
        return;
      }
      const isLt5M = file.size! / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.message.create('error', 'Image must smaller than 5MB!');
        observer.complete();
        return;
      }
      observer.next(isJpgOrPng && isLt5M);
      observer.complete();
    });
  };

  handleChange(info: NzUploadChangeParam): void {
    this.fileList = info.fileList.slice(-1);
  }

  handleRemove = (file: NzUploadFile): boolean => {
    this.fileList = [];
    return true;
  };

  onUpload(): void {
    if (!this.qrisName) {
      this.message.create('error', 'QRIS Name is required');
      return;
    }

    if (this.fileList.length === 0) {
      this.message.create('error', 'File QRIS is required');
      return;
    }

    const formData = new FormData();
    formData.append('name', this.qrisName);
    if (this.fileList[0]?.originFileObj) {
      formData.append('qris_image', this.fileList[0].originFileObj);
    }

    this.baseService.postDataWithToken(UPLOAD_QRIS, formData).subscribe({
      next: () => {
        this.message.create('success', 'QRIS uploaded successfully');
        this.fileList = [];
        this.qrisName = '';
        this.afterUpload.emit();
      },
      error: (err) => {
        this.message.create('error', err.error.meta.message);
      }
    })
  }
}
